export default __webpack_public_path__ + "static/media/FinanceRealCase-mobile.98355073.jpg";